<template>
  <div
    :class="componentClasses"
  >
    <Icon
      v-if="icon"
      :icon="icon"
    />
    <slot />
    <span v-if="value" class="stk-details-title-value">
      {{ value }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  icon: {
    type: String,
  },
  value: {
    type: String,
  },
  size: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-details-title',
  props.value ? `has-value` : '',
]);
</script>

<style>
.stk-details-title {
  display: flex;
  font-size: 0.875em;
  color: var(--stk-text-strong);
  font-weight: 500;
  align-items: center;
  gap: 0.25rem;
  line-height: 1.25rem;

  &.has-value {
    color: var(--stk-text-weak);
  }
}

.stk-details-title-value {
  color: var(--stk-text-strong);
  margin-inline-start: auto;
}
</style>
